import { HorizontalRule, Image as VuetifyImage } from "tiptap-vuetify";
import ColumnsNode from "./ColumnsNode";

function createColumnsActionRender(tooltip, iconName, nativeExtensionName) {
  // ExtensionActionRenderBtn is not exported; reuse the constructor from a stock extension.
  const sampleRender = new HorizontalRule({}).availableActions[0].render;
  const RenderBtn = sampleRender.constructor;
  const sampleIcons = new VuetifyImage({}).availableActions[0].render.options.icons;
  const IconClass = sampleIcons.md.constructor;

  return new RenderBtn({
    tooltip,
    icons: {
      md: new IconClass(iconName),
      fa: sampleIcons.fa,
      mdi: sampleIcons.mdi,
      mdiSvg: sampleIcons.mdiSvg,
    },
    nativeExtensionName,
  });
}

/**
 * Toolbar buttons + TipTap `columns` node (exactly two `column` children).
 * - Equal 2 columns
 * - Icon + text (narrow left column for an icon image)
 */
export default class TwoColumnsExtension {
  constructor(options = {}) {
    this.options = options;
    this.nativeExtensionInstance = new ColumnsNode(options);
  }

  get availableActions() {
    return [
      {
        render: createColumnsActionRender("Insert 2 columns", "view_column", "columns"),
      },
      {
        render: createColumnsActionRender("Insert icon + text", "view_sidebar", "columnsIcon"),
      },
    ];
  }
}
